"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.formatUtcDateTime = void 0;
const date_fns_1 = require("date-fns");
const date_1 = require("../../../constants/date");
const formatUtcDateTime = (value) => {
    if (!value)
        return '';
    const date = new Date(value);
    if (!(0, date_fns_1.isValid)(date))
        return '';
    const utcDate = (0, date_fns_1.parseISO)(date.toISOString().slice(0, -1));
    return (0, date_fns_1.format)(utcDate, date_1.DATE_TIME_FORMAT);
};
exports.formatUtcDateTime = formatUtcDateTime;
